<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">备案</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">开始备案</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">判断备案类型</div>
      </div>
      <div class="panel-body">
        <div class="alert-warn">
          请填写以下信息开始备案，系统将根据您填写的域名和证件，自动验证您的备案类型。（如果您没有背景幕布，建议先<router-link to="/beian3" class="z-color-a">[购买幕布]</router-link>，现场拍照用户无需购买。）
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="200px" class="beian-ruleForm" element-loading-background="rgba(0, 0, 0, 0.01)">
          <el-form-item label="主办单位所属区域：">
            <xbeian-city :province="cityInfo['province']" :city="cityInfo['city']" :area="cityInfo['area']" :DISTRICTS="DISTRICTS" v-model="cityInfo" v-loading="listLoading"></xbeian-city>
          </el-form-item>
          <el-form-item label="主办单位性质：" prop="nature" :show-message="!formFocus.nature">
            <el-select v-model="ruleForm.nature" placeholder="--请选择--" @focus="formFocus.nature = true" @blur="formFocus.nature = false">
              <el-option
                v-for="item in ruleForm.dwxz"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div class="icp-msg" v-show="">
              <em class="hoticon-top"></em>
              请选择您的主办单位性质，个人备案请选择个人，个体工商户有字号的请选择企业。
            </div>
            <div class="icp-tip" v-show="formFocus.nature">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请选择您的主办单位性质，个人备案请选择个人，个体工商户有字号的请选择企业。
              </div>
            </div>
          </el-form-item>
          <el-form-item label="主办单位证件类型：" prop="certificate" :show-message="!formFocus.certificate">
            <el-select v-model="ruleForm.certificate" placeholder="--请选择--" @focus="formFocus.certificate = true" @blur="formFocus.certificate = false">
              <el-option
                v-for="item in ruleForm.zjlx"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div class="icp-msg" v-show="">
              <em class="hoticon-top"></em>
              请选择您的主办单位性质，个人备案请选择个人，个体工商户有字号的请选择企业。
            </div>
            <div class="icp-tip" v-show="formFocus.certificate">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请选择主办单位证件类型
              </div>
            </div>
          </el-form-item>
          <el-form-item label="主办单位证件号码：" prop="number" :show-message="!formFocus.number">
            <el-input v-model="ruleForm.number" @focus="formFocus.number = true" @blur="formFocus.number = false"></el-input>
            <div class="icp-tip" v-show="formFocus.number">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请输入与您主办单位证件上完全一致的证件号码，请不要输入空格。
              </div>
            </div>
          </el-form-item>
          <el-form-item label="域名：" prop="domain" :show-message="!formFocus.domain">
            www.<el-input v-model="ruleForm.domain" style="width: 337px" @focus="formFocus.domain = true" @blur="formFocus.domain = false"></el-input>
            <!--<div class="icp-tip" ref="domain" style="display: none;float: right;" v-if="!formFocus.domain">
              <span style="color: #f56c6c;">{{domainMsg}}</span>
            </div>-->
            <div class="icp-tip" v-show="formFocus.domain">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请填写您要备案的网站域名
              </div>
            </div>
          </el-form-item>
          <el-form-item label="验证码：" prop="code" style="width: 980px" class="captcha">
            <el-input v-model="ruleForm.code" style="width: 132px"></el-input>
            <img :src="captcha" title="点击更换" class="error-img" @click="changeYzm">
            <a href="javaScript:;" class="error-link z-margin-left-15-precent" @click="changeYzm">看不清，换一张</a>
            <!--<div class="icp-tip" ref="code" style="display: none;float: right;">
              <span style="color: #f56c6c;">验证码输入不正确！</span>
            </div>-->
          </el-form-item>
          <el-form-item>
            <div class="z-display-inlineBlock z-lineHeight-20">
              <xbutton font="立即创建" type="orange" @XbuttonService="submitForm('ruleForm')"/>
            </div>
          </el-form-item>
        </el-form>

        <div class="alert-warn-lg clearfix">
          <div class="tip-title">
            温馨提示：
          </div>
          <div class="tips-container tips-left-container">
            <h4>个人备案资料：</h4>
            <div class="tips-content">
              <span>电子版资料项：</span>
              <div>
                <p>1. 身份证正反面彩色扫描件</p>
                <p>
                  2. 幕布照片<span class="text-tips">（半身照，腰部以上不可戴帽子或眼镜，双手垂立）</span>
                  <a class="z-color-a a-underline-link" href="/help/content_1142.html" target="_blank">下载幕布</a><router-link to="/beian3" class="z-color-a z-margin-left-10-precent a-underline-link">购买幕布</router-link>
                </p>
                <p>3. 域名证书</p>
                <p>4. 在本备案系统填写备案信息资料</p>
              </div>
            </div>
            <div class="tips-content">
              <span class="z-color-red">注意事项：</span>
              <div>
                <a class="z-color-a a-underline-link" href="/help/content_1125.html" target="_blank">暂时无法备案省份</a>
              </div>
            </div>
          </div>
          <div class="tips-container tips-right-container">
            <h4>企业备案资料：</h4>
            <div class="tips-content">
              <span>需邮寄项：</span>
              <div>
                <p>1. 网站备案授权书<span class="z-color-muted">（盖公章,主体负责人（法人）和网站负责人不是同一人时需提供）</span><a class="z-color-a a-underline-link" href="/help/content_1141.html" target="_blank">点击下载&gt;</a></p>
                <p>2. 真实性核验单<span class="z-color-muted">（在网站负责人签字处加盖公司公章）</span><a class="z-color-a a-underline-link" href="/help/content_1143.html" target="_blank">点击下载&gt;</a></p>
                <p class="z-color-66-orange">（提示：如可提供高清扫描件，直接系统附件上传即可，可不邮寄。）</p>
              </div>
            </div>
            <div class="tips-content">
              <span>电子版资料项：</span>
              <div>
                <p>1. 营业执照彩色扫描件</p>
                <p>2. 法人身份证原件扫描件</p>
                <p>3. 网站负责人身份证原件扫描件</p>
                <p>
                  4. 网站负责人照片<span class="z-color-muted">（站立上半身照片，不可戴帽子眼镜等）</span>
                  <a class="z-color-a a-underline-link" href="/help/content_1142.html" target="_blank">下载幕布</a><router-link to="/beian3" class="z-color-a z-margin-left-10-precent a-underline-link">购买幕布</router-link>
                </p>
                <p>5. 域名证书</p>
                <p>6. 在本备案系统中填写备案信息</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import XfromInput from 'commons/XfromInput.vue'
  import XbeianCity from 'commons/XbeianCity.vue'
  import Xbutton from 'components/commons/Xbutton.vue'
  import beianService from 'business/beianService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data() {
      return {
        listLoading:false,
        dialogLoading:false,
        checkdomian:false,
        labelPosition: 'right',
        DISTRICTS:[],
        cityInfo: {
          province:'北京市',
          city:'市辖区',
          area:'东城区'
        },
        cityId:{
          provinceid: 0,
          cityid: 1,
          districtid: 1
        },
        ruleForm: {
          dwxz:[],
          zjlx:[],
          nature: '',
          certificate: '',
          number:'',
          domain:'',
          code:''
        },
        rules: {
          nature: [
            { required: true, message: '请选择主办单位性质', trigger: 'change' }
          ],
          certificate: [
            { required: true, message: '请选择主办单位证件类型', trigger: 'change' }
          ],
          number: [
            { required: true, message: '请填写您单位的证件号码！', trigger: 'blur' }
          ],
          domain: [
            { required: true, message: '请正确填写您的网站域名！', trigger: 'blur' },
            { validator: async function (rule, value, callback) {
                let data = 'cmd=check_domain'+'&domain='+value
                let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
                if(vueData.response == 200){
                  callback()
                }else{
                  callback(new Error(vueData.msg))
                }
              },trigger: 'blur'}
          ],
          code: [
            { required: true, message: '请输入验证码！', trigger: 'blur' },
            { validator: async function (rule, value, callback) {
                let data = 'cmd=check_yzm'+'&yzm='+value
                let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
                if(vueData.response == 200){
                  callback()
                }else{
                  callback(new Error(vueData.msg))
                }
              },trigger: 'blur'}
          ]
        },
        yzm:false,
        domain:false,
        captcha:'https://api.sanfengyun.com/www/yzm.php?rnd='+Math.random(),
        formFocus: {
          nature: false,
          certificate: false,
          number:false,
          domain:false,
        },
      };
    },
    props:{
      hide:Boolean
    },
    components: {
      XfromInput,
      Xbutton,
      XbeianCity,
      XdialogLoading
    },
    mounted() {
      this.beianInfo()
    },
    computed: {
      nature() {
        return this.ruleForm.nature
      },
      /*code() {
        return this.ruleForm.code
      },*/
      certificate() {
        return this.ruleForm.certificate
      },
    },
    watch:{
      nature(){
        this.ruleForm.zjlx = [...this.zjlxArr.filter(item => item.dwflid === this.ruleForm.nature)]
        if(this.ruleForm.zjlx.length>0){
          this.ruleForm.certificate = this.ruleForm.zjlx[0].value
        }
      },
      /*code(newValue){
        if(newValue === ''){
          this.$refs.code.style.display = 'none'
        }
      },*/
      certificate(newValue){
        if(newValue == 2){
          this.rules.number.push({ validator: function (rule, value, callback) {
              let idCardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
              if (!idCardRegex.test(value)) {
                callback(new Error('请输入有效的18位身份证号！'))
              } else {
                callback();
              }
            },trigger: 'blur'})
        }else{
          this.rules.number.pop()
        }
      },
    },
    methods:{
      ...mapActions(['SETBEIAN']),
      async submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit()
          } else {
            return false;
          }
        });
      },
      async beianInfo() {
        this.listLoading = true
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST','cmd=get_dm')
        if(state.code === '000' ) {
          this.DISTRICTS = vueData.qy
          this.listLoading = false
          this.ruleForm.dwxz = vueData.dwxz.map((item, index) => {
            return {
              value: item.id,
              label: item.mc
            }
          })
          this.zjlxArr = vueData.zjlx.map((item, index) => {
            return {
              value: item.id,
              label: item.mc,
              dwflid: item.dwflid
            }
          })
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      changeYzm() {
        this.captcha = 'https://api.sanfengyun.com/www/yzm.php?rnd='+Math.random()
      },
      /*async checkCode() {
        if(this.ruleForm.code != ''){
          let data = 'cmd=check_yzm'+'&yzm='+this.ruleForm.code
          let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
          if(vueData.response == 200){
            this.yzm = true
            this.$refs.code.style.display = 'none'
          }else{
            this.yzm = false
            this.$refs.code.style.display = 'inline-block'
          }
        }
      },*/
      /*async checkDomain() {
        this.formFocus.domain = false
        if(this.ruleForm.domain != ''){
          let data = 'cmd=check_domain'+'&domain='+this.ruleForm.domain
          let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
          if(vueData.response == 200){
            this.domain = true
            this.$refs.domain.style.display = 'none'
          }else{
            this.domain = false
            this.domainMsg = vueData.msg
            this.$refs.domain.style.display = 'inline-block'
          }
        }
      },*/
      async submit() {
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].mc == this.cityInfo.province){
            this.cityId.provinceid = Number(this.DISTRICTS[i].id)
            let province = this.DISTRICTS[i].shi
            for(let j in province){
              if(province[j].mc == this.cityInfo.city){
                this.cityId.cityid=Number(province[j].id)
                let city = province[j].xian
                for(let k in city){
                  if(city[k].mc == this.cityInfo.area){
                    this.cityId.districtid=Number(city[k].id)
                  }
                }
              }
            }
          }
        }
        let data = 'cmd=ba_type_auto'+'&shengid='+ this.cityId.provinceid + '&shiid='+ this.cityId.cityid + '&xianid=' + this.cityId.districtid + '&dwxz=' + this.ruleForm.nature + '&zjlx=' + this.ruleForm.certificate + '&zjhm=' + this.ruleForm.number + '&domain=' + this.ruleForm.domain + '&yzm=' + this.ruleForm.code
        this.dialogLoading = true
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200 ) {
          this.id_root = vueData.id_root
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: '验证完成', click () {
              self.SETBEIAN(JSON.stringify(vueData.msg))
              if(vueData.msg.beian_path === 1){
                self.$router.push('/beian6')
              }
              if(vueData.msg.beian_path === 2){
                self.$router.push('/beian7')
              }
              if(vueData.msg.beian_path === 3){
                self.$router.push('/beian8')
              }
          }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      }
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .alert-warn {
    margin-bottom: 30px;
  }
  .beian-ruleForm .el-input,.el-select {
    width: 374px;
  }
  .captcha .el-form-item__error {
    left: 380px;
  }
  .icp-msg {
    color: #4074e1;
    border: solid 1px #4074e1;
    background: #ecf1fc;
    border-radius: 3px;
    position: relative;
    margin-top: 10px;
    font-size: 12px;
    line-height: 18px;
    padding: 10px;
    width: 352px;
  }
  .hoticon-top {
    position: absolute;
    top: -4px;
    left: 50px;
    background: url(../../assets/imgs/hoticon.png) no-repeat;
    background-position: 0 0;
    width: 6px;
    height: 4px;
  }
  em{
    font-style: normal;
    font-weight: 500;
  }
  .icp-tip {
    position: absolute;
    left: 375px;
    top: 0;
    margin-left: 10px;
    width: 400px;
    line-height: 32px;
    font-size: 12px;
  }
  .icp-tip .icp-msg {
    margin: 0 0 0 30px;
    padding: 6px 10px;
    width: 300px;
  }
  .icp-tip span {
    padding-left: 6px;
  }
  .hoticon-left {
    position: absolute;
    top: 12px;
    left: -4px;
    background: url(../../assets/imgs/hoticon.png) no-repeat;
    background-position: 0 -5px;
    width: 4px;
    height: 6px;
  }
  .icon-i {
    color: #4074e1;
    padding-left: 5px;
  }
  .error-link {
    color: #0066cc;
    font-size: 12px;
    text-decoration: underline;
    vertical-align: 1px;
  }
  .error-link:hover {
    color: #4074e1;
    text-decoration: underline;
  }
  .error-img {
    width: 100px;
    height: 30px;
    vertical-align: top;
    margin-left: 10px;
    cursor: pointer;
  }

  .tips-container {
    float: left;
    padding-top: 20px;
  }
  .tips-container h4 {
    font-weight: bold;
    color: #636566;
    font-size: 12px;
  }
  .tips-content {
    padding-top: 20px;
    font-size: 12px;
    color: #636566;
  }
  .tips-content > span {
    float: left;
  }
  .tips-content > div {
    overflow: hidden;
  }
  .tips-content p {
    margin: 0 0 10px;
  }
  .tips-left-container {
    width: 40%;
    margin-right: 2%;
  }
  .tips-right-container {
    width: 58%;
  }

  .alert-warn-lg .tip-title {
    position: relative;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    padding-left: 10px;
    font-weight: bold;
    color: #ff6600;
    font-size: 14px;
  }
  .alert-warn-lg .tip-title:after {
    position: absolute;
    bottom: -1px;
    left: 0;
    content: "";
    width: 80px;
    height: 2px;
    background: #ff6600;
  }
  .alert-warn.alert-white-bg {
    border: none;
    padding: 0px;
    background: #fff;
    line-height: 2em;
    color: #aaa;
  }
  .alert-warn.alert-white-bg .alert-warn-title {
    color: #ff8800;
  }
</style>



// WEBPACK FOOTER //
// src/pages/beian/beian1.vue